import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'roleModule'
})
export class RoleModulePipe implements PipeTransform {

  constructor() { }
  transform(module) {
    switch (module) {
      case 'administration':
        return 'Administración';
      case 'cargo':
        return 'Servicios';
      case 'guide':
        return 'Guías';
      case 'point':
        return 'Puntos';
      case 'payments':
        return 'Pagos';
      case 'help-desk':
        return 'Soporte';
      case 'notifications':
        return 'Notificaciones';
      case 'setting':
        return 'Configuración';
      case 'general':
        return 'General';
      case 'monitoring':
        return 'Monitoring'
      case 'routes':
        return 'Rutas';
      case 'analytics':
        return 'Analítica';
      case 'routing':
        return 'Ruteo';
      case 'reports':
        return 'Reportes';
      case 'fintech':
        return 'LoggiCash'
      case "seals":
        return "Precintos";
      case "legalDocuments":
        return "Documentos Legales";
      case "rndc":
        return "RNDC";
      case "satelliteTracking":
        return "Seguimiento por satélite";
      default:
        return module;
    }
  }

}
